export default function copy(data) {
  // console.log('copy', data, typeof data, typeof data === 'object')
  if(!data) return data;
  if(Array.isArray(data)) {
    return data.map(value => {
      // console.log('array', value);
      const v = copy(value);
      // console.log('array value', v);
      return copy(v);
    })
  }
  if(typeof data === 'object') {
    // console.log('is object', data, typeof data, typeof data === 'object')
    const entries = Object.entries(data);
    return entries.reduce((a, [key, value]) => {
      // console.log('reduce', key);
      const v = copy(value);
      // console.log('reduce value', value, v);
      // console.log('reduce accu')
      a[key] = v;
      return a;
    }, {})
  }
  return data;
}